<template>
  <div class="sider">
    <el-menu router style="height: 100%">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>参数管理</span>
        </template>
        <el-menu-item index="/params/units">单位管理</el-menu-item>
        <el-menu-item index="/params/record">参数集管理</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Sider',
  data () {
    return {

    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.sider {
  height: 100%;
}
</style>
